import React from "react";

const SuccessModal = ({ isOpen, onClose, message, language }) => {

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,.65)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 999999,
        padding: "20px"
      }}
    >
      <div
        style={{
          background: "white",
          borderRadius: "30px",
          maxWidth: "430px",
          width: "100%",
          padding: "26px",
          textAlign: "center",
          boxShadow: "0 25px 70px rgba(6,47,90,.22)",
          animation: "successPop .55s ease-out"
        }}
      >

        <div
          style={{
            width: "72px",
            height: "72px",
            borderRadius: "50%",
            background: "#0a447d",
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "40px",
            fontWeight: "bold",
            margin: "0 auto 20px auto",
            boxShadow: "0 8px 25px rgba(6,47,90,.25)"
          }}
        >
          ✓
        </div>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "700",
            marginBottom: "20px",
            color: "#062f5a"
          }}
        >
          {
            language === "es"
              ? "Formulario enviado"
              : language === "it"
              ? "Modulo inviato"
              : language === "is"
              ? "Eyðublað sent"
              : language === "de"
              ? "Formularz wysłany"
              : "Form Submitted"
          }
        </h2>

        <p
          style={{
            whiteSpace: "pre-line",
            lineHeight: "1.7",
            color: "#444",
            marginBottom: "30px"
          }}
        >
          {message}
        </p>

        <button
          onClick={onClose}
          style={{
            background: "#0a447d",
            color: "white",
            border: "none",
            borderRadius: "14px",
            padding: "14px 30px",
            cursor: "pointer",
            fontSize: "16px",
            fontWeight: "600"
          }}
        >
          {
            language === "es"
    ? "Entendido"
    : "OK"
          }
        </button>

      </div>
    </div>
  );
};

export default SuccessModal;